/* eslint-disable etc/no-commented-out-code */
import { logger as LOG } from '@sweetgreen/garnish';

const name = 'TELEMETRY';
const mockName = 'Telemetry Mock';

export const logger = LOG.extend(name);
export const mockLogger = LOG.extend(mockName);

// LOG.enable(name);
// LOG.enable(mockName);
